import { SimpleModal } from '@orientaction/components';
import { userHasService } from '@orientaction/utils';
import { OAMatchDialog } from '../../shared';
import PendingTestsModal from '../../Tests/MyTests/components/PendingTestsModal';
import RecrutementModal from '../../Profile/Edit/components/RecrutementModal';
import { UseHomePageReturn } from '../hooks/useHomePage';
import locale from '../locale.json';
import CandidatureModal from './CandidatureModal';

type HomePageOverlaysProps = {
  state: UseHomePageReturn;
};

const HomePageOverlays = ({ state }: HomePageOverlaysProps) => {
  const {
    user,
    disableMatch,
    candidature,
    loadingCandidature,
    loadingOAMatch,
    textPoppinOAMatch,
    testsToDo,
    openPendingTestsModal,
    setOpenPendingTestsModal,
    openRecrutementModal,
    setOpenRecrutementModal,
    idEbook,
    openCandidatureModal,
    openDeclineCandidatureModal,
    setOpenDeclineCandidatureModal,
    openEnglishModal,
    setOpenEnglishModal,
    openDialogOAMatch,
    setOpenDialogOAMatch,
    goToTest,
    logout,
    confirmCandidature,
    cancelAndDeleteCandidature,
    closeModalOA,
    closeAndRedirect,
    redirectToOAMatch,
    refreshUser,
  } = state;

  const isRecruitmentService = userHasService(user, 4);

  return (
    <>
      <PendingTestsModal
        open={openPendingTestsModal}
        tests={testsToDo}
        onClose={() => setOpenPendingTestsModal(false)}
        onTestClick={test => {
          setOpenPendingTestsModal(false);
          goToTest(test.id, test.title);
        }}
      />

      <RecrutementModal
        open={openRecrutementModal}
        user={user}
        onClose={() => setOpenRecrutementModal(false)}
        getUser={refreshUser}
        idEbook={idEbook}
        preventClose={isRecruitmentService}
        secondaryAction={
          isRecruitmentService
            ? { label: locale.recrutementLogout, onClick: logout }
            : { label: locale.recrutementLater, onClick: () => setOpenRecrutementModal(false) }
        }
      />

      <CandidatureModal
        open={openCandidatureModal}
        title={locale.candidatureModalTitle}
        message={locale.candidatureConfirmMessage.replace('{title}', candidature?.job?.title || '')}
        confirmLabel="Accepter"
        cancelLabel="Refuser"
        loading={loadingCandidature}
        onConfirm={confirmCandidature}
        onCancel={() => {
          setOpenDeclineCandidatureModal(true);
        }}
      />

      <SimpleModal
        open={openDeclineCandidatureModal}
        handleClose={() => setOpenDeclineCandidatureModal(false)}
        textClose={locale.candidatureDeclineNo}
        textClick={locale.candidatureDeclineYes}
        handleClick={cancelAndDeleteCandidature}
        title={locale.candidatureDeclineTitle}
        message={locale.candidatureDeclineMessage}
      />

      <SimpleModal
        open={openEnglishModal}
        handleClose={() => setOpenEnglishModal(false)}
        title={locale.englishModalTitle}
        message={locale.englishModalMessage}
      />

      {!disableMatch && (
        <OAMatchDialog
          open={openDialogOAMatch}
          loading={loadingOAMatch}
          text={textPoppinOAMatch}
          onClose={() => setOpenDialogOAMatch(false)}
          onCancel={closeModalOA}
          onConfirm={redirectToOAMatch}
          onRedirect={closeAndRedirect}
        />
      )}
    </>
  );
};

export default HomePageOverlays;
